/**
* @description warstwa pokazująca html, alerty, potykacze
* @module modal
*/
app.service('modal', function ($global, console, loading, lazyLoad, broker, activeElement, front, focusTrap) {
	var messages = [];
	var modalsCallbackClose = [];
	function setActiveElement(params = {}) {
		activeElement.set(null, params.internal);
	}
	function focusActiveElement(params = {}) {
		activeElement.focus(params.internal);
	}
	/**
	* @function open
	* @description wyświetla warstwę
	* @param {text} id identyfikator warstwy
	*/
	function open(id, params) {
		if (isExist(id)) {
			setActiveElement();
			var defaults = {
				hashTracking: false
			};
			var $modal = $('[data-remodal-id=' + id + ']').filter('.remodal');
			if ($modal.length) { // przypadek gdy w kodzie na nowo pojawia sie ten sam modal, to usuwamy ten wstepnie wygenerowany, a otwieramy juz otwarty; usuwanie tylko dla przypadku istnienia modali z klasą .remodal (inaczej usuna sie wszystkie)
				$modal.filter(':not(.remodal)').remove();
			}
			console.log('otwieramy warstwę: ' + id);
			var modal = $('[data-remodal-id=' + id + ']').remodal($.extend(true, defaults, params));
			loading.stop();
			modal.open();
			if ($modal.find('.remodal-close').length) {
				$modal.find('.remodal-close').focus();
			}
			if (params) {
				modalsCallbackClose[id] = function () {
					if (params.callbackClose) {
						params.callbackClose();
					}
					// focusActiveElement();
				}
			}
			return modal;
		} else {
			console.log('NIE ISTNIEJE MODAL');
		}
	}
	/**
	* @function alert
	* @description wyświetla warstę z przekazanym tekstem i guzukiem OK
	* @param {text} text tekst do pokazania
	*/
	function alert(text, callback) {
		if (typeof (text) === 'object') {
			$result = $('<ul/>');
			text.forEach(function (a, i) {
				$result.append($('<li/>').text(a));
			})
		} else {
			$result = $('<p/>').append(text && text.length ? text : 'pusty komunikat');
		}

		loading.stop();
		generate({
			cssClass: 'alert-modal',
			id: 'alert',
			callbackClose: callback || null,
			content: $result[0].outerHTML,
			buttons: [
				{
					text: 'Rozumiem',
					cssClass: 'btn btn-second',
					click: function () {
						close();
					}
				}
			]
		});
	}
	function close(focusActive = true) {
		var $modal = $('.remodal-is-opened .remodal');
		if ($modal.length) {
			focusTrap.reset();
			if(!focusActive){
				activeElement.reset();
			}
			$modal.remodal().close();
			if (focusActive) {
				focusActiveElement();
			}
		}
	}
	function callbackClose($modal, callback) {
		$modal['$modal'].on('click', '.remodal-close', function () {
			callback();
		});
	}
	/**
	 * @function isExist
	 * @description sprawdza czy warstwa o podanym id istnieje
	 * @param {text} id identyfikator warstwy
	 */
	function isOpen(id) {
		if (!id) {
			return $('.remodal-wrapper.remodal-is-opened').length ? true : false;
		} else if (isExist(id)) {
			return $('[data-remodal-id=' + id + ']').remodal().getState() == 'opened';
		}
		return false;
	}
	function isExist(id) {
		return $('[data-remodal-id=' + id + ']').length ? true : false;
	}
	function destroy(id) {
		try {
			$('.remodal-wrapper [data-remodal-id=' + id + ']').remodal().destroy();
		} catch (e) { }
	}
	/**
	* @function removeRemodals
	* @description usuwa wszystkie modale poza tymi, które umieszczono w $safeModals
	*/
	function removeRemodals() {
		clearMessages();
		const $safeModals = $('#alert, #message'); //id modali, które nie zostaną usunięte
		const $modalsToRemove = $('.remodal').not($safeModals);
		if ($modalsToRemove.length) {
			$modalsToRemove.each(function () {
				destroy($(this).data('remodalId'))
			})
		}
		broker.trigger('REMOVE_ALL_MODALS');
	}
	/**
	* @function generate
	* @description generuje warstę z przekazanymi danymi
	*/
	function addMessage(text, cssClass = '') {
		messages.push({ text, cssClass });
	}
	function showMessages() {
		if (messages.length) {
			var message = messages.shift();
			let $content = $('<p/>').attr('class', message.cssClass).append(message.text);
			generate({
				cssClass: 'message-modal',
				id: 'message',
				content: $content[0].outerHTML,
				callbackClose: function () {
					discardMessage();
				},
				buttons: [
					{
						cssClass: 'btn btn-second',
						text: 'Rozumiem',
						click: function () {
							close();
						}
					}
				]
			});
		}
	}
	function discardMessage() {
		setTimeout(function () {
			showMessages();
		}, 2000);
	}
	function clearMessages() {
		messages = [];
	}
	function generate(params) {
		var options = {
			content: null,
			header: null,
			modifier: null,
			closeAutofocus: true,
			callbackOpen: null,
			callbackClose: null,
			closeOnEscape: true,
			close: true,
			show: true,
			id: null,
			lang: false,
			overwrite: true,
			hashTracking: false,
			buttons: {}
		};
		$.extend(true, options, params);
		if (options.overwrite && options.id) {
			$('[data-remodal-id=' + options.id + ']').parent().remove();
		}
		setActiveElement();
		var $html = $('<div class="remodal" aria-modal="true" role="dialog"></div>');
		if (options.id) {
			$html.attr('id', options.id);
			$html.attr('data-remodal-id', options.id);
		} else {
			//gdy brak id, wygeneruj w formacie modal-(1 - 999999)
			options.id = 'modal-' + (Math.floor(Math.random() * (999999 - 1)) + 1);
			$html.attr('id', options.id);
			$html.attr('data-remodal-id', options.id);
		}
		if (options.lang) {
			$html.attr('lang', options.lang);
		}
		if (options.cssClass) {
			$html.addClass(options.cssClass);
		}
		if (options.close) {
			var $closeButton = $(`<button type="button" data-remodal-action="close" ${options.closeAutofocus && options.show ? 'autofocus ' : ''}class="remodal-close" aria-label="Zamknij okno dialogowe"></button>`);
			$html.append($closeButton);
		}
		if (options.header) {
			$html.append('<h2>' + options.header + '</h2>');
		}
		if (options.content) {
			$html.append(options.content);
		}
		if (options.buttons.length) {
			var buttons = $('<div class="buttons"/>');
			$(options.buttons).each(function (i, n) {
				var button = $('<button type="button"/>');
				if (n.text) {
					button.text(n.text);
				}
				if (n.cssClass) {
					button.addClass(n.cssClass);
				}
				if (n.click) {
					button.click(function () {
						n.click();
					});
				}
				buttons.append(button).addClass('buttons-' + options.buttons.length);
			});
			$html.append(buttons);
		}
		$('body').append($html);
		var modalHandler = $html.remodal({
			hashTracking: false,
			modifier: options.modifier,
			closeOnEscape: !(options.closeOnEscape === false || options.close === false),
			closeOnOutsideClick: options.close
		});
		if (options.show) {
			loading.stop();
			modalHandler.open();
		}
		if (options.callbackOpen) {
			options.callbackOpen.call(modalHandler);
		}
		if (options.callbackClose && options.id) {
			modalsCallbackClose[options.id] = options.callbackClose;
		}
		return modalHandler;
	}
	function setElements() {
		$(document).on('closed', function (e) {
			focusTrap.reset();
			focusActiveElement();
			if (e && e.target && modalsCallbackClose[e.target.dataset.remodalId]) {
				modalsCallbackClose[e.target.dataset.remodalId]();
			}
		});
	}
	function setEvents() {
		$('body').on('click', '.close-modal, .js-close-modal', function (event) {
			close();
		}).on('click', '.js-internal-modal-back', function (event) {
			event.preventDefault();
			closeInternal();
		});

		$(document).on('opened', '.remodal', function () {
			var text = '';
			var $title = $(this).find('h2:eq(0)');

			if ($title && $title.text() != '') {
				text = $title.text();
			} else {
				text = $(this).text();
			}
			focusTrap.set($(this));
			eventLog({
				id: $(this).data('remodal-id'),
				content: text.replace(/[\t\n\r]/g, '').substr(0, 50) //v2 - patrz komentarz wyżej
			});
		});

		//if(!front.isAjaxPageEnabled() || !front.isRwd()) {
		$(document).on('closing', '.remodal', function (e) {
			if (location.hash == '#modalState') {
				window.history.back();
			}
		});

		$(window).on('popstate', function (event) {  //pressed back button
			if (event.state !== null) { //    zamykam modala na powrot mobile button
				close();
			}
		});
		//}


	}

	function eventLog(options) {
		app.logEvent({
			id: 'fancybox',
			f03: document.location.href,
			f04: options.id,
			f05: options.content,
			// f04: (options.href?options.href.replace(/\s/g, ''):'inline'), //oryginalne z desktopa
			// f05: (!options.href?$.trim($(options.content).text()).substr(0,50):'') //oryginalne z desktopa
		});
	}

	function closeInternal(){	// szukay otwartego modala i zamyka wewnętrzny modal
		const $modal = $('.remodal.remodal-right.remodal-is-opened');
		if($modal.length){
			$modal.addClass('closing-internal-modal'); // na potrzeby poprawnej prezentacji animacji (translateX + display)
			$modal.removeClass('show-internal-modal');
			focusTrap.reset($modal.find('.internal-modal'));
			focusActiveElement({internal: true});
			setTimeout(function() {
				$modal.removeClass('closing-internal-modal');
			}, 200);
		} else {
			console.log('Nie znaleziono modala do zamknięcia wewnętrznego modala');
		}
	}
	function showInternal(){	// szuka otwarty modal i otwiera wewnętrzny modal
		const $modal = $('.remodal.remodal-right.remodal-is-opened');
		if($modal.length){
			setActiveElement({internal: true});
			focusTrap.set($modal.find('.internal-modal'));
			$modal.addClass('opening-internal-modal'); // na potrzeby poprawnej prezentacji animacji (display + translateX)
			setTimeout(function() {
				$modal.addClass('show-internal-modal');
				$modal.removeClass('opening-internal-modal');
				$modal.find('.internal-modal button').first().focus();
				lazyLoad.update();		// na wewnętrznej warstwie mogą być obrazki
			}, 200);
		} else {
			console.log('Nie znaleziono modala do pokazanie wewnętrznego modala');
		}
	}

	function init() {
		setElements();
		setEvents();
	}
	$global('showModal', generate);
	$global('closeModal', close);
	$(document).ready(function () {
		init();
		showMessages();
	});
	$global('alert', alert);
	$global('addMessage', addMessage);
	return {
		open,
		alert,
		addMessage,
		showMessages,
		clearMessages,
		generate,
		close,
		callbackClose,
		isOpen,
		isExist,
		destroy,
		removeRemodals,
		closeInternal,
		showInternal
	};
});
